<template>
  <div id="cc-full-leaderboard-app" :style="style()" ref="app">
    <style>
      body{color: red;}
    </style>
    
    
    <div class="cc-leaderboard-header row">
        <div class="view-full-leaderboard col-12 col-sm-4" :style="{backgroundColor:settings.primaryColor}">
            <a :href="leaderBoardUrl" target="_blank">View Full LeaderBoard</a>
        </div>
        <div class="leaderboards-list col-sm-4 col-12" :style="{backgroundColor:settings.secondaryColor}">
            <select v-model="event" :style="style()">
                <option v-for="event in settings.events" :key="event.id" :value="event.id">{{ event.name }}</option>
            </select>
            <material-icons icon="arrow_drop_down"/>
        </div>
        <div class="leaderboard-groups col-sm-4 col-12" :style="{backgroundColor:settings.secondaryColor}">
            <select v-model="group" :style="style()">
                <option v-for="(event, index) in groups" :key="index" :value="index">{{ event }}</option>
            </select>
            <material-icons icon="arrow_drop_down"/>
        </div>
    </div>
    <cc-results :results="results" :max-height="settings.maxHeight" :top-x="settings.topX" :workouts="workouts"></cc-results>
    <div v-if="loading" class="loading"></div>
  </div>
</template>

<script>
import MaterialIcons from './components/Icon.vue'
import Results from './components/Results.vue'
export default {
  name: 'FullLearBoard',
  metaInfo() {
    let link = []
    if(this.settings.isGoogleFont){
      link.push({
        rel:"stylesheet",
        href:"https://fonts.googleapis.com/css?family=" + this.settings.font.replace(/ /g,"+")
      })
    }
    return {link:link}
  },
  data () {
    return {
      settings: cc_full_leaderboard_settings.settings,
      leaderBoardUrl: cc_full_leaderboard_settings.event_url,
      events: cc_full_leaderboard_settings.events,
      event: cc_full_leaderboard_settings.event_id,
      groups: cc_full_leaderboard_settings.groups,
      group: cc_full_leaderboard_settings.group_id,
      //
      results: cc_full_leaderboard_settings.results.Athletes,
      workouts: cc_full_leaderboard_settings.results.Workouts,
      appWidth: 0,
      loading: false
    }
  },
  components: { MaterialIcons, 'cc-results': Results },
  mounted() {
    this.appWidth = this.$refs.app.clientWidth;
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.appWidth = this.$refs.app.clientWidth;
      });
    })
  },
  methods: {
    style () {
      var style = {};
      if(this.settings.font){
        style.fontFamily = this.settings.font;
      }
      if(this.settings.fontSize){
        style.fontSize = this.settings.fontSize;
      }
      return style;
    },
    nextWorkouts(){
      this.startWorkouts += this.numberWorkoutsToShow
    },
    prevWorkouts(){
      this.startWorkouts -= this.numberWorkoutsToShow;
    }
  },
  watch: {
    event (val){
      this.leaderBoardUrl = this.settings.events.find(e => {
        return e.id === val
      }).url
      this.loading = true;
      jQuery.ajax({
        url: cc_full_leaderboard_settings.ajax_url,
        type: 'POST',
        data: {
          action: 'cc_full_leaderboard_ajax',
          event_id: val
        },
        success: (res) => {
          this.groups = res.data;
          this.group = Object.keys(this.groups)[0];
          this.loading = false;
        }
      });
    },
    group (val) {
      this.loading = true;
      jQuery.ajax({
        url: cc_full_leaderboard_settings.ajax_url,
        type: 'POST',
        data: {
          action: 'cc_full_leaderboard_ajax',
          event_id: this.event,
          group_id: val
        },
        success: (res) => {
          if(typeof res.data == 'undefined'){
            alert('Something went wrong, please try again later!');
          }else{
            this.workouts = res.data.Workouts;
            this.results = res.data.Athletes;
            this.startWorkouts = 0;
          }
          this.loading = false;
        }
      });
    },
    orderBy (){
      this.orderASC = true;
    },
    appWidth (val){
      if(val < 767){
        this.numberWorkoutsToShow = 1;
        this.showFlag = false;
      }else if(val >= 768 && val < 992){
        this.numberWorkoutsToShow = 2;
        this.showFlag = false;
      }else if(val >= 992){
        this.numberWorkoutsToShow = 3;
        this.showFlag = true;
      }
      this.startWorkouts = 0;
      this.endWorkouts = this.numberWorkoutsToShow;
    },
    startWorkouts (val){
      this.endWorkouts = val + this.numberWorkoutsToShow;
    }
  }
}
</script>

<style>
#cc-full-leaderboard-app {
  position: relative;
  max-width: 1140px;
  margin: 0 auto;
  min-height: 300px;
}

#cc-full-leaderboard-app .loading{
  background-color: rgba(255, 255, 255, 0.5);
  background-image: url(./assets/CC_Loader.gif);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100px 100px;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
<style lang="scss" scoped>
  @import url('//fonts.googleapis.com/icon?family=Material+Icons');
  @import 'assets/grid.scss';
  .sort-order{
    font-size: 13px;
  }
  input.athlete-search{
    border: 1px solid #e0e0e0;
    padding: 0 30px;
    font-size: 13px;
    border-radius: 0;
    line-height: 33px;
    &::-webkit-input-placeholder{
      color: #e3e3e3;
    }
    &::-moz-placeholder{
      color: #e3e3e3;
    }
    &:-ms-input-placeholder{
      color: #e3e3e3;
    }
  }
  .search-icon{
    position: absolute;
    font-size: 17px;
    line-height: 35px;
    left: 9px;
  }
  .view-full-leaderboard,
  .leaderboards-list,
  .leaderboard-groups{
      color: #fff;
      line-height: 27px;
  }
  .cc-leaderboard-header{
      display: flex;
      position: sticky;
      top: 0;
      z-index: 99;
  }
  .cc-leaderboard-header select{
    background: transparent;
    border: none;
  }
  .arrow-up.icon {
    color: #000;
    position: absolute;
    margin-left: 10px;
    margin-top: 3px;
    width: 1px;
    height: 16px;
    background-color: currentColor;
  }
  .arrow-up.icon:before {
    content: '';
    position: absolute;
    left: -5px;
    top: 1px;
    width: 10px;
    height: 10px;
    border-top: solid 1px currentColor;
    border-right: solid 1px currentColor;
    -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
  }
  ul.row{
    margin: 0;
    padding: 0;
    list-style: none;
  }
  ul.result-header{
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    li{
      border-top: 1px solid #e0e0e0;
      border-left: 1px solid #e0e0e0;
      padding: 10px 12px;
      span{
        font-weight: bold;
      }
    }
  }
  ul.result-header-second{
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    >li{
      border-left: 1px solid #e0e0e0;
      font-size: 12px;
      color: #9E9E9E;
      padding: 5px 12px;
    }
  }
  li.row-odd{
    background: #fcfcfc;
  }
  .cc-leaderboard-header{
    select{
      height: 40px;
      line-height: 40px;
      color: #fff;
      width: 100%;
      -webkit-appearance: none;
      -moz-appearance: none;
      padding: 0 12px;
      position: relative;
      z-index: 10;
      &::-ms-expand{
        display: none;
      }
    }
    .view-full-leaderboard{
      a{
        padding-left: 12px;
        display: block;
        line-height: 40px;
        color: #fff;
      }
    }
  }
  .leaderboards-list{
    border-right: 1px solid #e0e0e0;
  }
  .leaderboard-groups,
  .leaderboards-list{
    position: relative;
    .material-icons{
      position: absolute;
      right: 10px;
      top: 7px;
      z-index: 1;
    }
  }
</style>